import { render, staticRenderFns } from "./BatchSuccess.vue?vue&type=template&id=5106625a&scoped=true"
import script from "./BatchSuccess.vue?vue&type=script&lang=js"
export * from "./BatchSuccess.vue?vue&type=script&lang=js"
import style0 from "./BatchSuccess.vue?vue&type=style&index=0&id=5106625a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5106625a",
  null
  
)

export default component.exports